import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from "rxjs";

import { TranslationService } from './translation.service';

@Injectable()
export class CultureInterceptor implements HttpInterceptor {

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (TranslationService.currentCulture != null && !TranslationService.isDefaultCultureEmpty()) {
            req = req.clone({
                headers: req.headers.set('X-Culture', TranslationService.currentCulture.code)
            });   
        }

        return next.handle(req);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/common/cultureInterceptor.service.ts